module.exports = __webpack_public_path__ + "img/steam.01722536.svg";